import { Component } from '@angular/core';
import { ROUTES } from '../components/sidebar/sidebar.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UserPermissionsComponent } from '../user-permissions/user-permissions.component';

interface User {
  name: string;
  id: number;
}

@Component({
  selector: 'app-permissions',
  templateUrl: './permissions.component.html',
  styleUrl: './permissions.component.scss'
})
export class PermissionsComponent {

  users: User[] = [];

  username: string = '';
  password: string = '';

  constructor(
    public service: DigisubservicesService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private toaster: ToastrService,
  ) { }

  ngOnInit(): void {
    this.loadUsers();
  }

  addUser() {
    console.log('Username:', this.username);
    console.log('Password:', this.password);
    // Call your API here to save user
    alert(`User ${this.username} added successfully!`);
    this.username = '';
    this.password = '';
  }

  loadUsers() {
    const roleFromSession = sessionStorage.getItem("role");
    const deptFromSession = sessionStorage.getItem("dept");

    this.service.getUsers().subscribe({
      next: (res: any) => {
        if (res.status === 'success') {

          debugger

          if (roleFromSession === '1') {
            // Admin role: show all departments
            this.users = res.users;
          } else if (roleFromSession === '2') {
            // Normal user role: show only their own department
            this.users = res.users.filter(user => {
              if (!user.dept_id) return false;

              const userDeptIds = String(user.dept_id).split(',');
              const sessionDeptIds = String(deptFromSession).split(',');

              // Check if any dept in userDeptIds exists in sessionDeptIds
              return userDeptIds.some(id => sessionDeptIds.includes(id));
            });

          } else {
            // Fallback: show none or handle differently
            this.users = [];
          }
        } else {
          this.toaster.error('Failed to load users');
        }
      },
      error: (err) => {
        console.error(err);
        this.toaster.error('Failed to load users');
      }
    });
  }

  // Action button handler
  handleAction(user: User) {
    debugger
    this.dialog.open(UserPermissionsComponent, {
      width: '600px',
      data: user
    });
  }

}